/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesPriceListResponseDto } from '../../models/sales-price-list-response-dto';

export interface PriceListsControllerRemoveComplexity$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the price list.
 */
  id: string;

/**
 * The code of the complexity to remove.
 */
  complexityCode: string;
}

export function priceListsControllerRemoveComplexity(http: HttpClient, rootUrl: string, params: PriceListsControllerRemoveComplexity$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, priceListsControllerRemoveComplexity.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.path('complexityCode', params.complexityCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesPriceListResponseDto>;
    })
  );
}

priceListsControllerRemoveComplexity.PATH = '/o2-sales/price-lists/{tenant}/{id}/complexities/{complexityCode}';
